import mixpanel from 'mixpanel-browser';

//mixpanel.init('63b6a2e8025111485769d28bc9ad5c48', {debug: true}); 

mixpanel.init('63b6a2e8025111485769d28bc9ad5c48'); 

//let env_check = process.env.NODE_ENV === 'production';
let env_check = true;

let actions = {
  identify: (id) => {
    if (env_check) mixpanel.identify(id);
  },
  alias: (id) => {
    if (env_check) mixpanel.alias(id);
  },
  track: (name, props) => {
      // console.log ("tracking action");
    if (env_check) mixpanel.track(name, props);
  },
  people: {
    set: (props) => {
      if (env_check) mixpanel.people.set(props);
    },
  },
};

export let Mixpanel = actions;